import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_11.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/show');
  const shareText = encodeURIComponent('Showcasing What Makes Your Workplace Irresistible!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>showcasing — Outstanding Workplaces</title>
        <meta property="og:title" content="showcasing — Outstanding Workplaces" />
        <meta property="og:description" content="Showcasing What Makes Your Workplace Irresistible" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778043585/i_11_tkgsml.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/show" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="showcasing — Outstanding Workplaces" />
        <meta name="twitter:description" content="Showcasing What Makes Your Workplace Irresistible" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778043585/i_11_tkgsml.jpg" />
      </Helmet>

       <div className="sight_11_page_wrapper">
      <div className="sight_11_content_container">

        <div className="sight_11_section_one">

          {/* TITLE */}
          <h1 className="sight_11_page_title">
            Showcasing What Makes Your Workplace Irresistible
          </h1>

          {/* ROW */}
          <div className="sight_11_row">

            {/* LEFT SIDE */}
            <div className="sight_11_left">
              <div className="sight_11_image_wrapper">
                <img
                  src="/assets/i_11.jpg"
                  alt="Team meeting discussion"
                  className="sight_11_blog_image"
                />
              </div>




                {/* SHARE SECTION */}
                <div className="sight_11_share_section">
                  <span className="sight_11_share_text">Share :</span>
                  <div className="sight_11_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_11_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_11_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_11_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_11_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

            <p className="sight_11_intro_paragraph">
               An Employee Value Proposition (EVP) is the unique set of benefits, experiences, and opportunities that an organization offers to its employees in exchange for their skills, capabilities, and engagement. It is the core promise that defines why employees would choose to work for, stay with, and advocate for your company.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_11_right">
              <div className="sight_11_ad_card">
                <img src="/assets/bc_1.png" className="sight_11_ad_bg" />
                <div className="sight_11_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_11_ad_badge" />

                <div className="sight_11_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                   <button 
  className="sight_11_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_11_section">

          <div className="sight_11_topics">

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">What is Employee Value Proposition and Why It Matters</h2>
              <ul className="sight_11_topic_list">
                <li>Define EVP and its role in employer branding.</li>
                <li>Explain how a strong EVP attracts and retains top talent.</li>
                <li>Include examples from top companies.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">Key Components of a Strong EVP</h2>
              <ul className="sight_11_topic_list">
                <li>Compensation & benefits</li>
                <li>Career development opportunities</li>
                <li>Work-life balance</li>
                <li>Company culture & values</li>
                <li>Recognition & rewards</li>
                <li>Include tips for evaluating your EVP strengths</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">How to Align EVP with Company Culture</h2>
              <ul className="sight_11_topic_list">
                <li>Show the connection between EVP and company mission, vision, and values.</li>
                <li>Explain how alignment increases employee engagement and satisfaction.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">⁠EVP for Different Generations in the Workforce</h2>
              <ul className="sight_11_topic_list">
                <li>Address Gen Z, Millennials, Gen X, and Boomers.</li>
                <li>Highlight tailored approaches in perks, recognition, and career paths.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">Measuring the Effectiveness of Your EVP</h2>
              <ul className="sight_11_topic_list">
                <li>Metrics to track: employee retention, engagement surveys, candidate experience, employer brand perception.</li>
                <li>Tools and strategies for continuous improvement.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">Real-Life Examples of Exceptional EVPs</h2>
              <ul className="sight_11_topic_list">
                <li>Case studies of companies with standout EVPs (Google, Microsoft, Salesforce, etc.)</li>
                <li>Lessons learned and actionable takeaways for smaller organizations.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">Communicating Your EVP Internally and Externally</h2>
              <ul className="sight_11_topic_list">
                <li>Internal: onboarding, newsletters, internal campaigns.</li>
                <li>External: career pages, social media, job postings.</li>
                <li>How communication strengthens your employer brand.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">EVP and Employee Engagement</h2>
              <ul className="sight_11_topic_list">
                <li>How EVP influences motivation, productivity, and loyalty.</li>
                <li>Link EVP strategies to performance outcomes.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">EVP in a Hybrid or Remote Work Environment</h2>
              <ul className="sight_11_topic_list">
                <li>Adaptations for flexible work models.</li>
                <li>Benefits, culture, and career growth opportunities for remote teams.</li>
              </ul>
            </div>

            <div className="sight_11_topic_item">
              <h2 className="sight_11_topic_heading">Future Trends in EVP and Employer Branding</h2>
              <ul className="sight_11_topic_list">
                <li>Personalization of EVP</li>
                <li>ESG and DEI integration into EVP</li>
                <li>Digital-first approaches and AI in talent experience</li>
              </ul>
            </div>

          </div>
        </div>

      </div>
   </div>
    </>
  );
}

export default BlogPage;

